"use client";

import SearchInputBase from "@/components/search/search-input-base";
import { useRouter, useSearchParams } from "next/navigation";
import { KeyboardEvent, MouseEvent, useCallback, useTransition } from "react";

interface SearchInputProps {
  readonly initialValue?: string;
}

export default function SearchInput({ initialValue = "" }: SearchInputProps) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [isPending, startTransition] = useTransition();

  const handleSearch = useCallback(
    (term: string): void => {
      startTransition(() => {
        const newParams = new URLSearchParams(searchParams.toString());

        newParams.set("q", term.trim());
        newParams.delete("page");
        newParams.delete("spell");

        if (newParams.toString()) {
          router.push(`/search?${newParams.toString()}`);
        } else {
          router.push("/");
        }
      });
    },
    [router, searchParams, startTransition],
  );

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearch(e.currentTarget.value);
    }
  };

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const input = e.currentTarget.parentElement?.querySelector("input");
    if (input) {
      handleSearch(input.value);
    }
  };

  return (
    <SearchInputBase
      initialValue={initialValue}
      handleKeyDown={handleKeyDown}
      handleClick={handleClick}
      disabled={isPending}
      className={isPending ? "animate-pulse" : ""}
    />
  );
}
